import { jsx as _jsx } from "react/jsx-runtime";
import { autocompleteClasses } from "../../../components/atoms/Autocomplete/index.js";
import Icon from "../../../components/atoms/Icon/index.js";
export default {
    defaultProps: {
        clearOnEscape: true,
        clearIcon: _jsx(Icon, { type: "xmark" }),
        popupIcon: _jsx(Icon, { type: "caret-down" }),
    },
    styleOverrides: {
        root: ({ theme }) => ({
            [`& .${autocompleteClasses.popupIndicator}`]: {
                transition: theme.transitions.create(["transform", "background-color"], {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeInOut,
                }),
            },
        }),
        popupIndicatorOpen: {
            transform: "rotate(-180deg)",
        },
    },
};
